let timeoutTools = {showTimeout: null, setResolvedExternally: null};

export const registerGlobalShowTimeout = (tools) => {
    timeoutTools = tools;   
}

export const globalShowTimeout = () => timeoutTools;